import { render, staticRenderFns } from "./departed.vue?vue&type=template&id=149fb9be&scoped=true"
import script from "./departed.vue?vue&type=script&lang=js"
export * from "./departed.vue?vue&type=script&lang=js"
import style0 from "./departed.vue?vue&type=style&index=0&id=149fb9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149fb9be",
  null
  
)

export default component.exports